import { render, staticRenderFns } from "./LabelDesc.vue?vue&type=template&id=78e55593"
import script from "./LabelDesc.vue?vue&type=script&lang=js"
export * from "./LabelDesc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports